// @flow

import "./feature-brands.scss";
import Swiper from "swiper/dist/js/swiper.min.js";
import "swiper/dist/css/swiper.min.css";

new Swiper("#brand-slider", {
    loop: true,
    slidesPerView: 6,
    speed: 1000,
    autoplay: {
        delay: 2000
    },
    breakpoints: {
        // when screen is <= 1200
        "1200": {
            slidesPerView: 4
        },
        // when screen is <= 768
        "768": {
            slidesPerView: 3
        }
    }
});
